import type { ReactNode } from 'react'
import type { KOutcome, TMOutcome } from '../engine/types'

interface MachinePanelProps {
  eyebrow: string
  title: string
  outcome: KOutcome | TMOutcome
  output?: ReactNode
  narration: string
  renderer: ReactNode
  controls: ReactNode
  details?: ReactNode
}

export function MachinePanel({
  eyebrow,
  title,
  outcome,
  output,
  narration,
  renderer,
  controls,
  details,
}: MachinePanelProps) {
  return (
    <section className="km-machine-panel" aria-label={title}>
      <header className="km-machine-header">
        <div>
          <div className="km-machine-eyebrow">{eyebrow}</div>
          <h3>{title}</h3>
        </div>
        <MachineStatus outcome={outcome} output={output} />
      </header>
      <p className="km-step-narration" aria-live="polite">{narration}</p>
      <div className="km-renderer-stage">{renderer}</div>
      {controls}
      {details}
    </section>
  )
}

export function MachineStatus({
  outcome,
  output,
}: {
  outcome: KOutcome | TMOutcome
  output?: ReactNode
}) {
  return (
    <div className={`km-status km-status-${outcome}`}>
      <span>{outcome === 'running' ? 'Running' : outcome === 'result' ? 'Result' : 'No result'}</span>
      {output ? <strong>{output}</strong> : null}
    </div>
  )
}

export function CurrentStepCard({ lines }: { lines: Array<[label: string, value: string]> }) {
  return (
    <dl className="km-step-card">
      {lines.map(([label, value]) => (
        <div key={label}>
          <dt>{label}</dt>
          <dd>{value}</dd>
        </div>
      ))}
    </dl>
  )
}
